import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

const StudentProgressWeeklyPerformanceChartWidget = observer((props = {}) => {
  const { onlyRenderInnerWidgetContent, t } = props;

  const { appManager, classroomManager, studentProgressManager, userManager } = useContext(MobXProviderContext);
  const { classroomProgressData } = studentProgressManager;

  // Set default values when props are not provided
  const hasAssignments = props.hasAssignments !== undefined ? props.hasAssignments :
    Object.keys(classroomProgressData.grades).length > 0;
  const loading = props.loading !== undefined ? props.loading : (
    appManager.initializingApp || !userManager.loaded || !classroomManager.loaded
  );

  const WeeklyPerformanceChart = SatCoreComponent('WeeklyPerformanceChart');

  const noScoresYet = t('noScoresYet');
  // eslint-disable-next-line max-len
  const ariaLabelWeekGrades = ((hasAssignments && classroomProgressData?.weekGrades?.length) ? classroomProgressData.weekGrades.map((weekGrade) => {
    return t('ariaLabelWeekGrade', {
      averagePercent: (weekGrade?.averageScore >= 0 ? `${weekGrade.averageScore.toFixed()}%` : t('unknown')),
      end: weekGrade?.end || t('unknown'),
      start: weekGrade?.start || t('unknown'),
      submittedCount: weekGrade?.submittedCount >= 0 ? weekGrade.submittedCount : t('unknown'),
      submittedCountAssignments: weekGrade?.submittedCount !== 1 ? t('assignments') : t('assignment')
    });
  }) : [noScoresYet]).join(' ');

  const ariaLabelWeeklyPerformanceWidget = t('ariaLabelWeeklyPerformanceWidget', {
    ariaLabelWeekGrades
  });

  const innerWidgetContent = (
    <>
      {(!loading && hasAssignments && classroomProgressData?.weekGrades?.length) ? (
        <div aria-hidden={true} className='weekly-performance-container'>
          <WeeklyPerformanceChart
            data={classroomProgressData.weekGrades}
            /* t={t} */ width={320} />
        </div>
      ) : (
        <div aria-hidden={true} className='no-scores'>
          <p>{noScoresYet}</p>
        </div>
      )}
    </>
  );

  return !onlyRenderInnerWidgetContent ? (
    <div aria-label={ariaLabelWeeklyPerformanceWidget || t('noScoresYet')}
      className='StudentProgressWeeklyPerformanceChartWidget StudentProgressWidget widget weekly-performance-widget' tabIndex='0'>
      <h2 aria-hidden={true} className='w-title'>
        {t('WeeklyPerformanceLabel', 'Missing weekly performance label translation')}
      </h2>
      {innerWidgetContent}
    </div>
  ) : innerWidgetContent;
});

export default StudentProgressWeeklyPerformanceChartWidget;

SatCoreRegister('StudentProgressWeeklyPerformanceChartWidget', StudentProgressWeeklyPerformanceChartWidget);
